import React from 'react';
import './Footer.css';

export default function Footer() {
  return <div className="footer">© Hana Acciaioli & Emily Sellers 2023</div>;
}
